import React from 'react';
import {Link} from 'react-router-dom';
import './CtaBand.css';
import company from '../config/company';
import ctaBg from '../assets/images/cta-bg.webp';

const CtaBand = () => (
  <section
    className="cta-band"
    style={{'--cta-img': `url(${ctaBg})`}}
    aria-labelledby="cta-title"
  >
    <div className="cta-band__inner">
      <div className="cta-band__text">
        <p className="kicker cta-band__kicker">Wir für Sie</p>
        <h2 id="cta-title">Lernen wir uns kennen.</h2>
        <p>
          Kostenlos und unverbindlich. Wir klären gemeinsam, welche Unterstützung zu Ihrer
          Situation passt, und kümmern uns um Verordnungen, Anträge und die Abrechnung mit
          den Kassen.
        </p>
      </div>
      <div className="cta-band__actions">
        <Link className="btn btn--light" to="/kontakt">Kostenlos beraten lassen</Link>
        <a className="cta-band__phone" href={`tel:${company.phoneIntl}`}>
          oder direkt anrufen: <strong>{company.phone}</strong>
        </a>
      </div>
    </div>
  </section>
);

export default CtaBand;
